export default "__VITE_ASSET__CIivEr2K__"